import React, { useRef, useState, useEffect } from "react";
import { Tooltip } from "antd";

const TruncatedText = ({ text, maxWidth, placement = "top", style = {} }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    };
    checkTruncation();
    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [text]);

  const textEl = (
    <span
      ref={textRef}
      style={{
        ...style,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: maxWidth || "100%",
        display: "inline-block",
      }}
    >
      {text}
    </span>
  );

  return isTruncated ? (
    <Tooltip title={text} placement={placement}>
      {textEl}
    </Tooltip>
  ) : (
    textEl
  );
};

export default TruncatedText;
